
<section class="gh">
  @for (item of items; track item; let i = $index) {
    <div>
      <!-- <p>Test : {{i}}</p> -->
      <ng-container [ngTemplateOutlet]="(item.customHeader.templateRef || default_header)" [ngTemplateOutletContext]="{$implicit:item, index:i, toggle:getToggleState(i), expanded:expanded.has(i)}"></ng-container>
      <div class="display-content" [class.expanded]="expanded.has(i)">
        <ng-container [ngTemplateOutlet]="(item.content.templateRef || default_content)"></ng-container>
      </div>
    </div>
  }
</section>

<ng-template #default_header></ng-template>
<ng-template #default_content><div><p>Default Content</p></div></ng-template>
